import Vue from 'vue';
import Router from 'vue-router';
import AppNotFound from '@/common/layout/pages/AppNotFound';
import AppForbidden from '@/common/layout/pages/AppForbidden';
import AppError from '@/common/layout/pages/AppError';

// System
// import LoginCuentaTarjetaCiudadania from '@/components/admin/auth/LoginCuentaTarjetaCiudadania';
import LoginDjbr from '@/components/admin/auth/LoginDjbr';

// DJBR
import Djbrd from '@/components/djbrd/dashboard';

import DatosGenerales from '@/components/declaracion/datosGenerales';
import Bienes from '@/components/declaracion/bienes';
import Deudas from '@/components/declaracion/deudas';
import Parentesco from '@/components/declaracion/parentesco';
import Apoderado from '@/components/declaracion/apoderado';
import Borrador from '@/components/declaracion/borrador';
// import Aprobacion from '@/components/declaracion/aprobacion';
import Finalizar from '@/components/declaracion/finalizar';
// import FinalizarCiudadania from '@/components/declaracion/finalizarCiudadania';
// import FinalizarNormal from '@/components/declaracion/finalizarNormal';
import Validar from '@/components/djbrd/Validar';
import Portal from '@/components/djbrd/portal';
import HeaderPortal from '@/components/djbrd/headerPortal';
import CrearCuenta from '@/components/portal/login/CrearCuenta';
import ActivarTarjeta from '@/components/portal/login/ActivarTarjeta';
import Password from '@/components/portal/login/RecuperarContrasenia';
import Cambiar from '@/components/portal/login/CambiarContrasenia';

// Datos Generales
// import Tramite from '@/components/ceritificar/tramite';
// import ValidaFirma from '@/components/ceritificar/valida_firma';
// import Firma from '@/common/util/firma';
// import Transaccion from '@/components/ceritificar/transaccion';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'portal',
      component: Portal
    },
    {
      path: '/header-portal',
      name: 'HeaderPortal',
      component: HeaderPortal
    },
    {
      path: '/declaracion',
      name: 'inicio',
      component: Djbrd
    },
    {
      path: '/login-djbr',
      name: 'Login-Djbr',
      component: LoginDjbr
    },
    {
      path: '/datos-generales',
      name: 'DatosGenerales',
      component: DatosGenerales
    },
    {
      path: '/bienes',
      name: 'Bienes',
      component: Bienes
    },
    {
      path: '/deudas',
      name: 'Deudas',
      component: Deudas
    },
    {
      path: '/parentesco',
      name: 'Parentesco',
      component: Parentesco
    },
    {
      path: '/apoderado',
      name: 'Apoderado',
      component: Apoderado
    },
    {
      path: '/borrador',
      name: 'Borrador',
      component: Borrador
    },
    {
      path: '/transaccion',
      name: 'Finalizar',
      component: Finalizar
    },
    {
      path: '/crear-cuenta',
      name: 'CrearCuenta',
      component: CrearCuenta
    },
    {
      path: '/activar-tarjeta',
      name: 'ActivarTarjeta',
      component: ActivarTarjeta
    },
    {
      path: '/password',
      name: 'Password',
      component: Password
    },
    {
      path: '/cambiar',
      name: 'Cambiar',
      component: Cambiar
    },
    {
      path: '/validar',
      name: 'Validar',
      component: Validar
    },
    {
      path: '/404',
      component: AppNotFound
    },
    {
      path: '/403',
      component: AppForbidden
    },
    {
      path: '/500',
      component: AppError
    },
    {
      path: '*',
      component: AppNotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js